<template>
  <div class="mid-nav">
    <div v-for="li in menuArray" :key="li.id" @click="navgaoterRouter(li)">
      <div class="menu-list">
        <div class="icon">
          <img
            :src="li.img ? li.img : navIcon.programImg"
            v-if="li.id == 'program'"
          />
          <img
            :src="li.img ? li.img : navIcon.selectImg"
            v-else-if="li.id == 'select'"
          />
          <img
            :src="li.img ? li.img : navIcon.knowledgeImg"
            v-else-if="li.id == 'knowledge'"
          />
          <img
            :src="li.img ? li.img : navIcon.liveImg"
            v-else-if="li.id == 'live'"
          />
          <img
            :src="li.img ? li.img : navIcon.mySubordinate"
            class="new-add"
            v-else-if="li.id == 'mySubordinate'"
          />
          <img
            :src="li.img ? li.img : navIcon.homeworkWall"
            class="new-add"
            v-else-if="li.id == 'homeworkWall'"
          />
          <img :src="li.img ? li.img : navIcon.defaultIcon" v-else />
        </div>
        <span>{{ li.name }}</span>
        <!-- <span v-else>{{li.name_en}}</span> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    menuArray: {
      type: Array,
    },
  },
  activated() {
    if (localStorage.getItem("_user_data_language") == "zh-cn") {
      this.localLang = 1;
    } else {
      this.localLang = 0;
    }
  },
  data() {
    return {
      navList: [],
      navIcon: {
        // program图标
        programImg: require("@/assets/img/new/nav_st.png"),
        // select图标
        selectImg: require("@/assets/img/new/nav_xxk.png"),
        // knowledge图标
        knowledgeImg: require("@/assets/img/new/nav_zsh.png"),
        // live图标
        liveImg: require("@/assets/img/new/nav_lv.png"),
        // mySubordinate图标
        mySubordinate: require("@/assets/img/new/nav_leader.png"),
        // homeworkWall图标
        homeworkWall: require("@/assets/img/new/nav_wall.png"),
        // default图标
        defaultIcon: require("@/assets/img/new/nav_ex.png"),
      },
      localLang: localStorage.getItem("_user_data_language") == "zh-cn" ? 1 : 0,
    };
  },
  mounted() {},
  methods: {
    navgaoterRouter(li) {
      if (li.id == "program") {
        this.$router.push({ path: "/main/learning_camp" });
      } else if (li.id == "select") {
        this.$router.push({ path: "/main/elective_lib" });
      } else if (li.id == "knowledge") {
        this.$router.push({ path: "/main/knowledge_exchange" });
      } else if (li.id == "live") {
        this.$router.push({ path: "/main/living" });
      } else if (li.id == "mySubordinate") {
        this.$router.push({ path: "/main/sub_index" });
      } else if (li.id == "homeworkWall") {
        this.$router.push({ path: "/main/workingWall" });
      } else if (li.id == "toBeEndNotification") {
        this.$router.push({ path: "/main/expiring" });
      }
    },
  },
};
</script>

<style scoped lang="less">
@import "~@/assets/sass/color.less";
.mid-nav {
  display: flex;
  align-items: center;
  width: 100%;
  overflow-x: auto;
  background: white;
  padding: 0.25rem 0;
  &::-webkit-scrollbar {
    /*隐藏滚轮*/
    display: none;
  }
  .menu-list {
    min-width: 1.1rem;
    white-space: nowrap;
    text-align: center;
    margin: 0 0.3rem;
    color: #666;
    font-size: 0.26rem;
    .icon {
      background: @mColor;
      width: 0.8rem;
      margin: 0 auto 0.05rem;
      height: 0.8rem;
      border-radius: 50%;
      overflow: hidden;
      .new-add {
        width: 100%;
      }
      img {
        width: 100%;
        height: 100%;
        pointer-events: none; //防止图片点击放大
      }
    }
  }
}
</style>
